module.exports = __webpack_public_path__ + "static/g2-27b0ea98080ded74ff0becef766a6f87.jpg";